import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityFeatures = ({ language }) => {
  const translations = {
    en: {
      title: 'Enterprise Security',
      features: [
        {
          icon: 'Shield',
          title: 'End-to-End Encryption',
          description: 'All data transmitted is protected with AES-256 encryption'
        },
        {
          icon: 'Lock',
          title: 'Session Management',
          description: 'Automatic logout after 30 minutes of inactivity'
        },
        {
          icon: 'Eye',
          title: 'Activity Monitoring',
          description: 'All administrative actions are logged and auditable'
        },
        {
          icon: 'AlertTriangle',
          title: 'Threat Protection',
          description: 'Real-time detection of suspicious login attempts'
        }
      ]
    },
    zh: {
      title: '企业安全',
      features: [
        {
          icon: 'Shield',
          title: '端到端加密',
          description: '所有传输的数据都受到AES-256加密保护'
        },
        {
          icon: 'Lock',
          title: '会话管理',
          description: '30分钟不活动后自动登出'
        },
        {
          icon: 'Eye',
          title: '活动监控',
          description: '所有管理操作都被记录并可审计'
        },
        {
          icon: 'AlertTriangle',
          title: '威胁保护',
          description: '实时检测可疑登录尝试'
        }
      ]
    }
  };

  const t = translations?.[language];

  return (
    <div className="w-full max-w-md">
      <div className="bg-card rounded-lg shadow-card border border-border p-6">
        <h2 className="text-lg font-heading font-semibold text-foreground mb-6">
          {t?.title}
        </h2>
        <div className="space-y-4">
          {t?.features?.map((feature, index) => (
            <div key={index} className="flex items-start gap-4">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-medium text-foreground mb-1">
                  {feature?.title}
                </h3>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SecurityFeatures;